<template>
  <div>
    <div class="review-type-tab" v-if="$route.query.mode === 'review'">
      <p></p>
      <span :class="{ on: _reviewType === 1 }" @click="_reviewType = 1">我的答案</span>
      <span :class="{ on: _reviewType === 2 }" @click="_reviewType = 2">正确答案</span>
    </div>
    <div class="supplement answer-content">
      <div class="des" v-html="des"></div>
      <div class="supplement-content">
        <div class="supplement-content-code">
          <MonacoEditor :value.sync="value" :originalValue="originalValue" :editorConfig="editorConfig" ref="MonacoEditor" @parseRes="parseRes" />
        </div>
        <div class="supplement-content-note">
          <h4>提示区</h4>
          <div v-if="parseResObj">
            <p>
              编译结果：<span v-if="parseResObj.status === 1" class="green">{{ parseResObj.message }}</span
              ><span v-else>{{ parseResObj.message }}</span>
            </p>
          </div>
          <p v-else>编译结果：等待编译...</p>
        </div>
      </div>
    </div>
    <div class="action btn-group" v-if="showAction">
      <Button @click="diffVisible = true">查看默认代码</Button>
      <Button @click="handleCompile">编译</Button>
    </div>
    <!-- 默认代码对比弹窗 -->
    <Modal_ :visible="diffVisible" title="查看默认代码" :noCancel="true" :width="1200" @Ok="diffVisible = false">
      <p class="diff-title"><span>原始代码</span><span>当前代码</span></p>
      <div class="editor-container" v-if="originalValue && diffVisible">
        <MonacoEditor :value.sync="answer" :originalValue="originalValue" :editorConfig="diffEditorConfig" />
      </div>
    </Modal_>
  </div>
</template>

<script>
import MonacoEditor from '@/components/MonacoEditor'
import Modal_ from '@/components/Modal'
export default {
  components: {
    MonacoEditor,
    Modal_
  },
  props: {
    des: {
      type: String,
      default: ''
    },
    answer: {
      type: String,
      default: ''
    },
    originalValue: {
      type: String,
      default: ''
    },
    // 1-我的答案，2-正确答案
    reviewType: {
      type: Number,
      default: 1
    },
    // 是否显示内部的操作按钮组（默认代码、编译）
    showAction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      diffVisible: false, // 代码对比弹窗
      parseResObj: null, // 编译结果
      // 对比答案和默认密码的配置
      diffEditorConfig: {
        diffEditor: true,
        otherOptions: {
          readOnly: true
        }
      }
    }
  },
  computed: {
    value: {
      get() {
        return this.answer
      },
      set(val) {
        // 当不是回顾试卷的时候才更新值
        if (this.$route.query.mode !== 'review') {
          this.$emit('update:answer', val)
        }
      }
    },
    // 回顾试卷类型
    _reviewType: {
      get() {
        return this.reviewType
      },
      set(val) {
        this.$emit('update:reviewType', val)
      }
    },
    // 是否是回顾试卷
    isReview() {
      return this.$route.query.mode === 'review'
    },
    editorConfig() {
      const obj = this.isReview ? { otherOptions: { readOnly: true } } : {}
      return obj
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 修改a标签的数据
      const domA = document.querySelectorAll('.supplement .des a')
      domA.forEach(item => {
        if (item.getAttribute('href').indexOf('http') !== 0) {
          item.setAttribute('href', '/' + item.getAttribute('href'))
        }
        console.log(item.getAttribute('href'))
      })
      // 修改img标签的数据
      const domImg = document.querySelectorAll('.supplement .des img')
      domImg.forEach(item => {
        if (item.getAttribute('src').indexOf('http') !== 0) {
          item.setAttribute('src', '/' + item.getAttribute('src'))
        }
      })
    })
  },
  methods: {
    handleCompile() {
      this.$refs.MonacoEditor.handleParser()
    },
    // 代码验证结果
    parseRes(obj) {
      this.parseResObj = obj
    }
  }
}
</script>

<style lang="scss" scoped>
.supplement {
  display: flex;
  height: 560px !important;
  // height: 100%;
  // min-height: 300px;
  .des {
    width: 30%;
    height: 100%;
    background-color: #343d45;
    color: #fff;
    padding: 10px 20px;
    overflow-y: auto;
    border-right: 1px solid #1e1e1e;
    line-height: 20px;
  }
  &-content {
    width: 70%;
    height: 100%;
    &-note {
      height: 100px;
      background-color: #343d45;
      padding: 10px;
      color: #fff;
      line-height: 25px;
      overflow-y: auto;
      font-size: 13px;
    }
    &-code {
      height: calc(100% - 100px);
    }
  }
}
.diff-title {
  display: flex;
  margin-bottom: 10px;
  span {
    display: block;
    width: 43.7%;
    font-size: 15px;
    font-weight: bold;
  }
}
.editor-container {
  height: 300px;
  width: 100%;
}
</style>
